module.exports = __webpack_public_path__ + "img/btm4.6451dfea.png";